<template>
  <ModalContainer :show="show">
    <template slot="body">
      <div class="modal-content">
        <div class="d-flex align-items-center justify-content-end">
          <img
            src="../../assets/images/Vector (1).png"
            alt="close"
            class="cursor-pointer mt-1 mr-1"
            @click="$emit('close')"
          />
        </div>

        <div
          class="d-flex flex-column align-items-center justify-contents-center body"
        >
          <img
            src="../../assets/images/fluent-mdl2_bulk-upload.svg"
            alt=""
            class="w-30"
          />

          <p
            class="mt-3 font-20 font-weight-bolder"
            style="text-transform: capitalize; text-align: center;"
          >
            {{ heading }}
          </p>

          <p class="font-14 text-center">
            <span class="gray4" :class="msgWidth">
              {{ msg }}
            </span>
            <span
              style="color: rgba(33, 62, 122, 1); font-weight: 600; text-decoration: underline;"
              @click="triggerFileUpload"
              class="cursor-pointer"
            >
              {{ span }}
            </span>
            .
            <input
              class="d-none"
              accept=".csv"
              id="upload_csv"
              type="file"
              @change="handleFileUpload"
              ref="fileInput"
            />
          </p>

          <!-- Show uploaded file name here -->
          <p v-if="fileName" class="mt-2 font-14 text-center">
            <strong>File Name:</strong> {{ fileName }}
          </p>

          <div
            style="padding: 16px; box-shadow: 0px 4px 16px rgba(12, 12, 13, 0.08); border-radius: 8px; display: flex; align-items: center; gap: 0.3rem;"
          >
            <img src="../../assets/images/csv 1.svg" />
            <span>
              <span> Click </span>
              <span
                style="color: rgba(33, 62, 122, 1); text-decoration: underline;"
                @click="downloadCSVTemplate"
                class="cursor-pointer"
              >
                here
              </span>
              <span> to download CSV Template to use </span>
            </span>
          </div>

          <div
            class="mt-4 d-flex justify-contents-between align-items-center col-gap-2 w-100"
          >
            <button
              type="button"
              class="btn btn-primary w-100"
              @click="handleUpload"
              :disabled="!parsedData.length"
            >
              {{ action }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </ModalContainer>
</template>

<script>
import loadGoogleMapsApi from "load-google-maps-api";
import ModalContainer from "../../components/ModalContainer";
import Papa from "papaparse";
import { mapActions } from "vuex";

export default {
  name: "UploadFileModal",
  components: {
    ModalContainer,
  },
  props: {
    show: Boolean,
    heading: String,
    msg: String,
    span: String,
    action: String,
    msgWidth: {
      type: String,
      default: "msg_default",
    },
  },
  data() {
    return {
      parsedData: [],
      geocoder: null,
      fileName: "",
    };
  },
  methods: {
    ...mapActions(["uploadBulkShipment"]),
    close() {
      this.$emit("close");
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleLoading(isLoading) {
      this.$emit("isLoading", isLoading);
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileName = file.name;
        Papa.parse(file, {
          header: true,
          complete: this.processCSVData,
          skipEmptyLines: true,
        });
      }
    },
    processCSVData(result) {
      const data = result.data;
      this.parsedData = data.map((row) => {
        return {
          reference: row["Reference"] || "",
          vesselName: row["Vessel Name"] || "",
          eta: this.formatDate(row["ETA"]),
          pallet: row["Pallet"] || "",
          pointOfArrival: row["Point of Arrival"] || "",
          loadingDate: this.formatDate(row["Loading Date"]),
          departureDate: this.formatDate(row["Departure Date"]),
          product: row["Product"] || "",
          containerNumber: row["Container Number"] || "",
          originInfo: {
            name: row["Origin Name"] || "",
            address: {
              name: row["Origin Address"] || "",
              lat: 0,
              lng: 0,
            },
            region: row["Origin Region"] || "",
            country: row["Origin Country"] || "",
          },
          destinationInfo: {
            name: row["Destination Company"] || "",
            address: {
              name: row["Destination Address"] || "",
              lat: 0,
              lng: 0,
            },
            personOfContact: row["Destination Point of Contact"] || "",
            region: row["Destination Region"] || "",
            country: row["Destination Country"] || "",
          },
          assignedDevices: row["Device Imeis"]
            ? row["Device Imeis"].split(", ")
            : [],
        };
      });

      // Now, geocode the addresses
      this.geocodeAddresses();
    },
    formatDate(dateString) {
      if (!dateString) return null;

      const parsedDate = new Date(dateString);

      if (isNaN(parsedDate.getTime())) {
        const parts = dateString.split(/[\/\-\s:]/);
        if (parts.length >= 3) {
          const year = parts[2].length === 4 ? parts[2] : parts[0];
          const month = parts[1] - 1;
          const day = parts[0].length === 2 ? parts[0] : parts[2];
          const hours = parts[3] ? parts[3] : "00";
          const minutes = parts[4] ? parts[4] : "00";
          const seconds = parts[5] ? parts[5] : "00";

          const customParsedDate = new Date(
            year,
            month,
            day,
            hours,
            minutes,
            seconds
          );
          return isNaN(customParsedDate.getTime())
            ? null
            : customParsedDate.toISOString();
        }

        return null;
      }

      return parsedDate.toISOString();
    },
    geocodeAddresses() {
      this.parsedData.forEach((entry, index) => {
        const originAddress = `${entry.originInfo.address.name}, ${entry.originInfo.region}, ${entry.originInfo.country}`;
        this.geocodeAddress(originAddress, (lat, lng) => {
          this.$set(this.parsedData[index].originInfo.address, "lat", lat);
          this.$set(this.parsedData[index].originInfo.address, "lng", lng);
        });

        const destinationAddress = `${entry.destinationInfo.address.name}, ${entry.destinationInfo.region}, ${entry.destinationInfo.country}`;
        this.geocodeAddress(destinationAddress, (lat, lng) => {
          this.$set(this.parsedData[index].destinationInfo.address, "lat", lat);
          this.$set(this.parsedData[index].destinationInfo.address, "lng", lng);
        });
      });
    },
    geocodeAddress(address, callback) {
      if (this.geocoder) {
        this.geocoder.geocode({ address }, (results, status) => {
          if (
            status === window.google.maps.GeocoderStatus.OK &&
            results.length > 0
          ) {
            const result = results[0];
            const latLng = result.geometry.location;
            callback(latLng.lat(), latLng.lng());
          } else {
            console.error("Geocoding failed:", status);
            callback(0, 0);
          }
        });
      } else {
        console.error("Geocoder not initialized.");
        callback(0, 0);
      }
    },
    handleUpload() {
      this.handleLoading(true);
      this.uploadBulkShipment({ items: this.parsedData })
        .then(() => {
          this.handleLoading(false);
          this.close();
          this.$emit("showFileUploadSuccess");
        })
        .catch(() => {
          this.handleLoading(false);
        });
    },
    downloadCSVTemplate() {
      // Define your CSV header exactly as in the uploaded file
      this.handleLoading(true);
      const csvContent =
        "Reference,Loading Date,ETA,Departure Date,Vessel Name,Product,Pallet,Container Number,Point of Arrival,Device Imeis,Origin Name,Origin Address,Origin Region,Origin Country,Destination Company,Destination Region,Destination Point of Contact,Destination Country,Destination Address\n";

      // Add two sample rows of data, keeping the format consistent
      const sampleRow1 =
        '1234567890,13/08/2024,16/08/2024,14/08/2024,Black Pearl,Avocados,2,1234567890,Tzaneen,"72230497, 72230485",Main Packhouse,"3 Sirkel Dr Arbor Park, Tzaneen",Tzaneen,South Africa,Pitisa Fruit Ltd,Lagos,2348162345678,Nigeria,"15 Ajayi street, Opebi, Ikeja"\n';
      const sampleRow2 =
        '1234567232,20/08/2024,20/08/2024,14/08/2024,Black Pearl,Avocados,2,1234567890,Tzaneen,"72230441",Main Packhouse 2,"3 Sirkel Dr Arbor Park, Tzaneen",Tzaneen,South Africa,Pitisa Fruit Ltd,Lagos,2348162345233,Nigeria,"15 Ajayi street, Opebi, Ikeja"\n';

      // Concatenate header and sample rows
      const fullCsvContent = csvContent + sampleRow1 + sampleRow2;

      // Create a Blob from the CSV content
      const blob = new Blob([fullCsvContent], {
        type: "text/csv;charset=utf-8;",
      });

      // Create a link element, set its href and download attributes, and click it
      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "shipping-csv-template.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      this.handleLoading(false);
    },
  },
  watch: {
    parsedData: {
      handler() {
        console.log(this.parsedData, "this.parsedData");
      },
      deep: true,
    },
  },
  created() {
    loadGoogleMapsApi({
      key: process.env.VUE_APP_GOOGLE_API_KEY,
      libraries: ["places", "drawing", "geometry"],
    }).then(() => {
      if (window.google && window.google.maps) {
        this.geocoder = new window.google.maps.Geocoder();
      } else {
        console.error("Google Maps API not loaded.");
      }
    });
  },
};
</script>

<style scoped>
.modal-content {
  width: 100%;
}
.body {
  padding: 50px;
}
@media (max-width: 575.98px) {
  .modal-content {
    width: 100% !important;
  }
  .body {
    padding: 25px;
  }
}
</style>
